<template>
  <div id="app">
    <div class="loading" v-if="$root.loading.do">
      <div class="loading-icon"/>
    </div>
    <transition name="crossfade">
      <div class="transitioning" v-if="$root.transitioning"/>
    </transition>
    <div class="mailresponse" v-if="mailresponse.Message" v-on:click="mailresponse.Message = ''">
      <span v-if="mailresponse.Message=='confirmed'">Ihre E-Mailadresse ist bestätigt. Vielen Dank</span>
      <span v-else-if="mailresponse.Message=='link_error'">Der Bestätigungslink ist ungültig</span>
      <span v-else-if="mailresponse.Message=='sent'">Vielen Dank für Ihr Interesse. Wir haben Ihnen eine E-Mail mit einem Bestätigungslink geschickt.</span>
      <span v-else>{{mailresponse.Message}}</span>
    </div>
    <transition name="fade" mode="out-in">
      <router-view :key="`${$route.name == 'news' || $route.name == 'new' ? 'news' : $route.params.route}`" name="overlay"/>
    </transition>
    <transition name="crossfade" mode="out-in">
      <div class="ks-menu" v-if="$root.Menu === true" @click.stop="$root.Menu = false">
        <transition-group
            name="staggered-fade"
            tag="div"
            appear
            class="ks-roundbox"
            v-bind:css="false"
            v-on:enter="enter"
        >
          <router-link
            v-for="(p, index) in menu"
            :data-index="index"
            :style="{'color': p[1].color}"
            :key="`element-${p[1].route}`"
            :to="{name:p[1].controller, params: {route: p[1].route, id: p[1].id, stub: p[1].stub}}"
          >
            <span
              v-html="p[1].menu"
              @click="$root.scrollOffset = true"
            />
          </router-link>
        </transition-group>
      </div>
    </transition>
    <Switchy/>
    <!--<Applaus/>-->
    <Painter/>
  </div>
</template>

<script>
/* eslint-disable */
import Painter from '@/components/Painter'
import Switchy from '@/components/Switchy'
import Applaus from '@/components/Applaus'
import Velocity from 'velocity-animate'

export default {
  name: 'App',
  components: {
    Switchy,
    Painter,
    Applaus
  },
  computed: {
    menu() { 
      const asArray = Object.entries(this.$painterdata);
      return asArray.filter(e => e[1].menu)
    } 
  },
  data() {
    return({
      mailresponse: {
        Error: "",
        Message: "",
        Form: true,
      }
    });
  },
  async mounted () {
    if (this.$route.query.e && this.$route.query.h && this.$route.query.newsletter) {
        let response = await this.$http.post('/newsletter', this.$route.query);
        this.mailresponse = response.data;
    }
  },
  methods: {
    enter: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          { 
            opacity: 1
          },
          { 
            mobileHA: false,
            complete: done,
            duration: 100
          }
        )
      }, 500 + delay)
    }
  }
}
</script>


<style lang="scss">
  
  //@import url('https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  @import 'main';

  .mailresponse {
    z-index: 1000;
    backdrop-filter: blur(1rem);
    @include flex-vertical-center();
    width: 100%;
    @include vh(100);
    position: fixed;
  }

  .transitioning {
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: #FFF;
    z-index: 10000;
  }

  .loading {
    z-index: 1001;
    position: fixed;    
    left: var(--pd1);
    top: var(--pd1);
    &-icon {
      width: var(--pd1);
      height: var(--pd1);
      &:after {
        content: "⏳";
        position: absolute;
        display: block;
        animation: shake 3s linear infinite;
        font-size: var(--pd2);
      }
    }

    @keyframes shake {
      0% {
          transform:rotate(0deg)
      }
      5% {
          transform:rotate(180deg)
      }
      50% {
          transform:rotate(180deg)
      }
      55% {
          transform:rotate(360deg)
      }
      to {
          transform:rotate(360deg)
      }
    }





  }

  .ks-menu {
    z-index: 1001;
    backdrop-filter: blur(1rem);
    @include flex-vertical-center();
    width: 100%;
    @include vh(100);
    position: fixed;
    padding: 1rem;
    box-sizing: border-box;
    .ks-roundbox {
      display: flex;
      @include flex-vertical-center();
      flex-wrap: wrap;
      @include st() {
        flex-wrap: nowrap;
        flex-direction: column;
        padding: var(--pd2);
      }
      max-width: $wide-container;
      a {
        opacity: 0;
        display: inline-block;
        @include xlargefont;
        line-height: 7rem;
        &:not(:last-child) {
          &:after {
            content: ",";
            margin-right: 1rem;
            @include st() {
              display: none;
            }
          }
        }
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/App.vue